/**
 * (c) 2015 Ignite Sales, Inc.
 * User: aholmes
 * Date: 6/27/2016
 * Time: 3:13 PM
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { MessageDefinitionShape } from '../react/Shapes';

const FormError = ({ message }) => {
  return <div className="form-error">
    <FormattedMessage {...message} />
  </div>;
};

FormError.propTypes = {
  message: MessageDefinitionShape.isRequired
};

export default FormError;



/** WEBPACK FOOTER **
 ** ./src/main/js/common/util/FormError.js
 **/